import React, { useEffect } from 'react';
import { MedicalDataTypes } from '../../../../primary-record-types';
import { useVaccineTypeSearch } from '../../../../hooks/api/useVaccineTypeSearch';
import AutocompleteInput from '../../../v2BaseComponents/Inputs/AutocompleteInput';
import { FieldProps, getIn } from 'formik';

export type VaccineTypeInputOwnProps = {
    value: MedicalDataTypes.Coding | null;
    onChange: (value: MedicalDataTypes.Coding | null) => void;
    isDisabled?: boolean;
    medicalProfileId: string;
    title: string;
    onBlur?: () => void;
    onFocus?: () => void;
    testID?: string;
    error?: string;
};

export type VaccineTypeInputProps = VaccineTypeInputOwnProps;

const VaccineTypeInput: React.FC<VaccineTypeInputProps> = ({
    value,
    onChange,
    isDisabled,
    medicalProfileId,
    onBlur,
    ...toPass
}) => {
    const [textInputValue, setTextInputValue] = React.useState(value?.display || '');
    useEffect(() => {
        setTextInputValue(value?.display || '');
    }, [value?.display]);
    const { vaccineTypes, isLoading } = useVaccineTypeSearch({
        medicalProfileId: medicalProfileId,
        search: textInputValue,
    });

    return (
        <AutocompleteInput
            filteredItems={vaccineTypes}
            displayExtractor={(item) => item.display}
            keyExtractor={(item) => item.code}
            isLoadingItems={isLoading}
            onChange={onChange}
            textValue={textInputValue}
            textOnChange={setTextInputValue}
            isDisabled={isDisabled}
            value={value}
            onBlur={onBlur}
            {...toPass}
        />
    );
};

const VaccineTypeFormikInput: React.FC<
    Pick<VaccineTypeInputProps, 'medicalProfileId' | 'isDisabled' | 'testID' | 'title'> &
        FieldProps<MedicalDataTypes.Coding | null>
> = (props) => {
    const {
        field: { name, value },
        form: { handleBlur, setFieldValue, setFieldTouched },
        testID,
        ...toPass
    } = props;

    const validationError = getIn(props.form.errors, name);
    const touched = getIn(props.form.touched, name);
    const error = touched && validationError ? validationError : null;

    return (
        <VaccineTypeInput
            {...toPass}
            value={value}
            onChange={(e) => {
                setFieldValue(name, e);
            }}
            error={error}
            onBlur={() => {
                setFieldTouched(name);
                handleBlur(name);
            }}
            testID={testID || name}
        />
    );
};

export default React.memo(VaccineTypeFormikInput);
